module.exports = __webpack_public_path__ + "static/media/cq_ordinamento_def.fc5d7d13.svg";